import LoginPromo from './LoginPromo';

export default LoginPromo;
